import { getProgressGPTSuggestions } from 'api/services';
import useDataQuery from 'modules/shared/hooks/useDataQuery';

const useProgressGPTChatSuggestionData = () => {
    const progressGPTSuggestionQuery = useDataQuery(['progressGPTChatSuggestions'], () => getProgressGPTSuggestions());

    return {
        isLoading: progressGPTSuggestionQuery.isLoading,
        suggestions: progressGPTSuggestionQuery.data,
    };
};

export default useProgressGPTChatSuggestionData;
